import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

/**
 * Shared "coming soon" page for nav items that aren't built yet. The `title`
 * input is bound from the route's `data.title` via `withComponentInputBinding`.
 */
@Component({
  selector: 'app-placeholder-page',
  imports: [MatIconModule],
  templateUrl: './placeholder-page.html',
  styleUrl: './placeholder-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlaceholderPage {
  readonly title = input('Page');
}
